import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=8f4167ae&"
import script from "./Accueil.js?vue&type=script&lang=js&"
export * from "./Accueil.js?vue&type=script&lang=js&"
import style0 from "./Accueil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports